import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { Country } from '@/models/country.model';
import { checkCountryActivitiesEmptyCity } from '@/services/activity-info.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PanelGroup, useToaster } from 'rsuite';

interface CountryActionsProps{
    formObject?: Country;
};

const CountryActions: React.FC<CountryActionsProps> = ({formObject}) => {
  const [loadingCheckActivityEmptyCities, setLoadingCheckActivityEmptyCities] = useState(false);

  const nav = useNavigate();
  const toaster = useToaster();

  const handleCheckActivityEmptyCities = async () => {
    if(!formObject) return;

    setLoadingCheckActivityEmptyCities(true);
    try {
      const result: BaseResponseModel<number> = await checkCountryActivitiesEmptyCity(formObject.id);
      if (result.success) {
        toastSuccessMessage(`Activities checked successfully, ${result.result} activity is updated.`);
      }
    } catch (err) {
      const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
      toastErrorMessage(`Error in checking empty cities: ${errorModel?.errorMessage}`);
    }
    finally {
      setLoadingCheckActivityEmptyCities(false);
      toaster.clear(); 
    }    
  };

  return (
      <PageContent>
          <PanelGroup>
              <ActionPanel
                title='Check Activity Empty Cities'
                description='This action will check for any activity within this country that has empty cities and attempt to update them.'
                onClick={handleCheckActivityEmptyCities}
                loading={loadingCheckActivityEmptyCities}
              />
          </PanelGroup>
      </PageContent>
  );
};

export default CountryActions;
